/**
 * Append shg-breadcrumbs in Page-head
 *
 * <div class="shg-breadcrumbs js-shg-breadcrumbs hidden-xs">
 *   <div class="shell">
 *      {%- render 'breadcrumbs' -%}
 *   </div><!-- /.shell -->
 * </div><!-- /.shg-breadcrumbs -->
 *
 * @param {}
 * @return {void}
 */

const $breadcrumbs = $('.js-shg-breadcrumbs');

if ($breadcrumbs.length !== 0) {
  const $pageHead = $('.shogun-root > .shg-box-vertical-align-wrapper:nth-of-type(1) > .page-head').length ?
                    $('.shogun-root > .shg-box-vertical-align-wrapper:nth-of-type(1) > .page-head') :
                    $('.shogun-root > .shg-box-vertical-align-wrapper:nth-of-type(1) > .page-head-alt');

  if ($pageHead.length !== 0) {
    $pageHead.prepend($breadcrumbs).addClass('show-breadcrumbs');
  }
}
